module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image36.536259be.webp";